const constants = {
  primary: {
    main: '#00C3FF',
    light: '#CAF3FF',
    dark: '#006B8D'
  },
  secondary: {
    main: '#eb3343',
    light: '#ff6c6e',
    dark: '#b1001c'
  },
  tertiary: {
    main: '#00FFF3',
    light: '#70ffff',
    dark: '#00cbc0'
  },
  grey: {
    main: '#171F46',
    light: '#8F8F8F',
    lighter: '#F4F4F4'
  },
  white: {
    main: '#FFF'
  },
  breakpoints: {
    lg: 1280,
    md: 960,
    sm: 600,
    xl: 1920,
    xs: 0
  }
}

export default constants
